import { makeStyles } from "tss-react/mui";

const useTextFieldStyles = makeStyles()((theme) => ({
  root: {
    "& ::-ms-reveal": {
      display: "none",
    },
  },
  whiteFilled: {
    border: `1px solid ${theme.palette.strokes.defaultGrey}`,
    "& .MuiInputBase-root": {
      backgroundColor: theme.palette.surface.light,
      color: theme.palette.text.primary,
      "&.Mui-focused": {
        backgroundColor: theme.palette.surface.light,
      },
      "&.Mui-disabled": {
        backgroundColor: theme.palette.surface.light,
      },
    },
  },
  greyFilled: {
    "& .MuiInputBase-root": {
      backgroundColor: theme.palette.surface.bg,
      fontSize: "14px",
      color: theme.palette.text.secondary,
    },
  },
  greenFilled: {
    "& .MuiInputBase-root": {
      backgroundColor: theme.palette.surface.highlighted,
      color: theme.palette.text.primary,
    },
    "& .MuiSelect-icon": {
      color: theme.palette.text.accent,
    },
    "& .MuiFormLabel-root": {
      color: theme.palette.text.accent,
    },
  },
}));

export default useTextFieldStyles;
